import Action from "./Action";
import Route from "../Main/Route";
import {Serialization} from "../Main/Serializer";
import RouteIntermediate from "../Main/RouteIntermediate.js";
import RouteIntermediates from "../Main/RouteIntermediates.js";

export default class RouteMergeAction implements Action {
    readonly route2position: number;
    readonly route1Length: number;
    readonly newRoute1Intermediates: RouteIntermediates|null = null;
    private newRoute1IntermediateInstances: RouteIntermediate[]|null = null;

    private readonly clipRoute1: number;
    private readonly clipRoute2: number;

    public constructor(readonly route1: Route, readonly route2: Route) {
        this.route2position = route2.routeCollection.getRoutes().indexOf(route2);

        if (this.route2position === -1) {
            throw new Error('Invalid position');
        }

        this.route1Length = route1.getCoordinates().length;

        if (this.route2.getIntermediates() && !this.route1.getIntermediates()) {
            this.newRoute1Intermediates = new RouteIntermediates(this.route1);
        }

        this.clipRoute2 = 0;
        this.clipRoute1 = 0;

        const coordinates1 = this.route1.getCoordinates();
        const coordinates2 = this.route2.getCoordinates();
        if (coordinates1.length > 0) {
            const lastCoordinate1 = coordinates1[coordinates1.length - 1];
            let i;
            for (i = 0; i < coordinates2.length; i++) {
                if (
                    coordinates2[i][0] !== lastCoordinate1[0]
                    || coordinates2[i][1] !== lastCoordinate1[1]
                    || this.route2.getIntermediates()?.hasIntermediateAtIndex(i)
                ) {
                    break;
                }
            }

            this.clipRoute2 = i;
        }

        if (this.clipRoute2 === 0 && coordinates2.length > 0) {
            const firstCoordinate2 = coordinates2[0];
            let i;
            for (i = 0; i < coordinates1.length; i++) {
                if (
                    coordinates1[coordinates1.length - i - 1][0] !== firstCoordinate2[0]
                    || coordinates1[coordinates1.length - i - 1][1] !== firstCoordinate2[1]
                    || this.route1.getIntermediates()?.hasIntermediateAtIndex(coordinates1.length - i - 1)
                ) {
                    break;
                }
            }

            this.clipRoute1 = i;

            if (
                this.clipRoute1 === 0
                && coordinates1.length > 0
                && coordinates1[coordinates1.length - 1][0] === coordinates2[0][0]
                && coordinates1[coordinates1.length - 1][1] === coordinates2[0][1]
                && this.route1.getIntermediates()?.hasIntermediateAtIndex(coordinates1.length - 1)
                && this.route2.getIntermediates()?.hasIntermediateAtIndex(0)
            ) {
                // Als clipRoute1==0 && clipRoute2==0 omdat deze beide een intermediate bevatten, gaan deze
                // intermediates elkaar overlappen.
                alert('Waarschuwing: Na het samenvoegen overlappen 2 beslispunten elkaar. Los dit op alvorens verder te gaan.')
            }
        }
    }

    public apply(initial: boolean) {
        this.route2.routeCollection.detachRoute(this.route2);

        const newCoordinates = this.route1.getCoordinates().slice();
        newCoordinates.splice(newCoordinates.length - this.clipRoute1, this.clipRoute1, ...this.route2.getCoordinates().slice(this.clipRoute2));
        this.route1.setCoordinates(newCoordinates, false);

        if (this.newRoute1Intermediates) {
            this.route1.setIntermediates(this.newRoute1Intermediates);
        }

        if (this.route2.getIntermediates()) {
            if (this.newRoute1IntermediateInstances === null) {
                this.newRoute1IntermediateInstances = [];
                for (const intermediate of this.route2.getIntermediates().getIntermediatesList()) {
                    const newIntermediate = RouteIntermediate.unserialize(intermediate.serialize(), this.route1.getIntermediates())
                    newIntermediate.setIndex(this.route1Length - this.clipRoute1 + newIntermediate.index - this.clipRoute2);
                    newIntermediate.syncCoordinate();
                    this.newRoute1IntermediateInstances.push(newIntermediate);
                }
            }

            for (const intermediate of this.newRoute1IntermediateInstances) {
                this.route1.getIntermediates().addIntermediate(intermediate, false);
            }
            this.route1.getIntermediates().updateAfterAddOrRemove();
        }
    }

    public revert() {
        for (const intermediate of this.route1.getIntermediates()?.getIntermediatesList() ?? []) {
            if (intermediate.index >= this.route1Length - this.clipRoute1) {
                this.route1.getIntermediates().removeIntermediate(intermediate, false);
            }
        }
        this.route1.getIntermediates()?.updateAfterAddOrRemove();

        if (this.newRoute1Intermediates) {
            this.route1.setIntermediates(null);
        }

        this.route1.setCoordinates(this.route1.getCoordinates().slice(0, this.route1Length), false);

        this.route2.routeCollection.attachRoute(this.route2, this.route2position);
    }

    public merge(newAction: Action): boolean {
        return false;
    }

    public serializeForDebug(): Serialization {
        return {
            route1: this.route1.id,
            route2: this.route2.id,
            route2position: this.route2position,
        };
    }
}
